"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SceneLayoutChooser = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _underscore = require("underscore");
var _propTypes = require("prop-types");
var _SceneLayoutChooser = require("./SceneLayoutChooser.styled");
var _constants = require("../../constants");
var _propComparators = require("../../utils/propComparators");
var _SceneLayoutChooserItem = _interopRequireDefault(require("./SceneLayoutChooserItem"));
var _SceneLayerChooserUtils = require("./SceneLayerChooserUtils");
var _SceneLayoutChooserItemLightTheme = _interopRequireDefault(require("./SceneLayoutChooserItemLightTheme"));
var _hooks = require("../../hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SceneLayoutChooserComponent = function SceneLayoutChooserComponent(_ref) {
  var enableFeature = _ref.enableFeature,
    value = _ref.value,
    onChange = _ref.onChange,
    sources = _ref.sources,
    stagedSources = _ref.stagedSources,
    isStaged = _ref.isStaged,
    stagedSceneLayout = _ref.stagedSceneLayout,
    isCameraEnabled = _ref.isCameraEnabled,
    _ref$layouts = _ref.layouts,
    layouts = _ref$layouts === void 0 ? [] : _ref$layouts,
    viewPermissions = _ref.viewPermissions,
    user = _ref.user,
    _ref$programSources = _ref.programSources,
    programSources = _ref$programSources === void 0 ? [] : _ref$programSources;
  var isStudioLite = (0, _hooks.useStudioLiteContext)();
  var isLayoutSelected = function isLayoutSelected(sl) {
    return isStaged ? sl.title === stagedSceneLayout.title : value.title === sl.title;
  };
  var isLayoutAvailable = function isLayoutAvailable(sceneLayout) {
    var cameraLayouts = [_constants.SINGLE, _constants.FEATURED_PRESENTER, _constants.GRID, _constants.SIDE_BY_SIDE];
    var isCameraLayout = cameraLayouts.some(function (c) {
      return c.id === sceneLayout.id || c.title === sceneLayout.title;
    });
    if (isCameraLayout && !isCameraEnabled) {
      return false;
    }
    if (isStaged) {
      var actualStagedSources = Object.keys(stagedSources).map(function (sourceId) {
        return sources.find(function (_ref2) {
          var _id = _ref2._id;
          return _id === sourceId;
        });
      });
      return (0, _SceneLayerChooserUtils.checkLayoutAvailable)(sceneLayout.id, actualStagedSources, stagedSources);
    }
    if (isStudioLite) {
      return programSources.some(function (source) {
        return source.type === _constants.CAMERA_PRESENTER;
      });
    }
    return (0, _SceneLayerChooserUtils.checkLayoutAvailable)(sceneLayout.id, programSources, stagedSources);
  };
  var targetLayouts = isStudioLite ? _constants.SceneLayoutsLightTheme : _constants.SceneLayouts;
  var DisplayedSceneLayouts = (0, _underscore.isEmpty)(layouts) ? targetLayouts : targetLayouts.filter(function (sl) {
    return layouts.includes(sl === null || sl === void 0 ? void 0 : sl.id);
  });
  return _react["default"].createElement(_SceneLayoutChooser.Wrapper, null, DisplayedSceneLayouts.map(function (sl, index) {
    return isStudioLite ? _react["default"].createElement(_SceneLayoutChooserItemLightTheme["default"], (0, _extends2["default"])({
      layoutIndex: index + 1,
      selected: isLayoutSelected(sl),
      available: isLayoutAvailable(sl),
      key: "scene-layout-chooser-item-".concat(sl.title),
      isLayoutStaged: isStaged && sl.title === stagedSceneLayout.title,
      onClick: isLayoutAvailable(sl) ? onChange.bind(null, sl) : function () {}
    }, sl)) : _react["default"].createElement(_SceneLayoutChooserItem["default"], (0, _extends2["default"])({
      user: user,
      layoutIndex: index + 1,
      enableFeature: enableFeature,
      selected: isLayoutSelected(sl),
      available: isLayoutAvailable(sl),
      viewPermissions: viewPermissions,
      key: "scene-layout-chooser-item-".concat(sl.title),
      isLayoutStaged: isStaged && sl.title === stagedSceneLayout.title,
      onClick: isLayoutAvailable(sl) ? onChange.bind(null, sl) : function () {}
    }, sl));
  }));
};
SceneLayoutChooserComponent.propTypes = {
  value: (0, _propTypes.shape)({
    title: _propTypes.string.isRequired
  }).isRequired,
  enableFeature: _propTypes.bool,
  onChange: _propTypes.func.isRequired,
  sources: _propTypes.array,
  stagedSources: _propTypes.object,
  isStaged: _propTypes.bool,
  stagedSceneLayout: (0, _propTypes.shape)({
    title: _propTypes.string,
    id: _propTypes.string
  }),
  isCameraEnabled: _propTypes.bool.isRequired,
  layouts: _propTypes.array,
  viewPermissions: _propTypes.object,
  user: _propTypes.object,
  programSources: _propTypes.array
};
var SceneLayoutChooser = exports.SceneLayoutChooser = (0, _react.memo)(SceneLayoutChooserComponent, _propComparators.equalityComparator);